export function mapInteractionsToTranscript(interactions) {
  if (!Array.isArray(interactions)) return []

  const transcript = []
  for (const interaction of interactions) {
    if (interaction.userMessage) {
      transcript.push({ sender: 'USER', text: interaction.userMessage })
    }
    if (interaction.modelMessage) {
      transcript.push({ sender: 'MODEL', text: interaction.modelMessage })
    }
  }
  return transcript
}

export function mapSessionMetadata(session) {
  const name = session.name == null ? '' : String(session.name).trim()

  return {
    id: session.id,
    name: name && name.toLowerCase() !== 'null' ? name : null,
    lastUpdated: session.lastupdate || session.created,
  }
}
